export var NoteHeadingEnum;
(function (NoteHeadingEnum) {
    NoteHeadingEnum["id"] = "id";
    NoteHeadingEnum["date"] = "Date";
    NoteHeadingEnum["userName"] = "Username";
    NoteHeadingEnum["note"] = "Note";
    NoteHeadingEnum["stepName"] = "Step";
    NoteHeadingEnum["action"] = "Action";
})(NoteHeadingEnum || (NoteHeadingEnum = {}));
export const NoteHeadingEnumLookup = new Map([
    [NoteHeadingEnum.date, "date"],
    [NoteHeadingEnum.userName, "userName"],
    [NoteHeadingEnum.note, "note"],
    [NoteHeadingEnum.stepName, "stepName"]
]);
